export default "__VITE_ASSET__C$FScrcB__"